'use client';

import { Portal } from '@common/components';
import { usePathname } from 'next/navigation';

import { getMainWrapperElement } from '@/app/_components/MainWrapperPortal';
import { SUB_DOMAIN } from '@/constants';
import { SAFE_AREA_BOTTOM_IOS } from '@/modules/wello-app/_hooks/useMountAppData';
import { useDeviceInfoStore } from '@/stores/DeviceStore';
import { useGlobalStore } from '@/stores/GlobalStore';

import { DonationBnb } from './_components/DonationBnb';
import { LocalMarketBnb } from './_components/LocalMarketBnb';
import { getFloatingBnbKind } from './constants';

export const FloatingBnbController = () => {
  const pathname = usePathname();
  const hideBottomNav = useGlobalStore((state) => state.hideBottomNav);
  const isSafeAreaBottomVersion = useDeviceInfoStore(
    (state) =>
      state.subDomain === SUB_DOMAIN.WELLO_APP &&
      state.osType === 'ios' &&
      !!state.appVersion &&
      state.appVersion >= '3.1.10',
  );

  const activeBnb = hideBottomNav ? null : getFloatingBnbKind(pathname);

  return (
    <Portal renderTo={getMainWrapperElement}>
      <div
        className="fixed inset-x-0 bottom-10 z-20 hidden w-full mobile-tablet:block"
        style={{
          bottom: isSafeAreaBottomVersion
            ? 10 + SAFE_AREA_BOTTOM_IOS
            : undefined,
        }}
      >
        {activeBnb === 'donation' && <DonationBnb isMounted />}
        {activeBnb === 'localMarket' && <LocalMarketBnb isMounted />}
      </div>
    </Portal>
  );
};
